import { Link } from "react-router-dom";

import { Spinner } from "./spinner";

export function Button({
  children,
  className,
  size = "md",
  severity = "primary",
  loading = false,
  href,
  type,
  onClick,
  disabled,
}: {
  children: React.ReactNode;
  className?: string;
  size?: "sm" | "md" | "lg";
  severity?: "primary" | "secondary" | "danger";
  type: "button" | "submit" | "reset" | "route";
  loading?: boolean;
  href?: string;
  disabled?: boolean;
  onClick?: () => void;
}) {
  const isDisabled = disabled || loading;

  const sizeClassName =
    size === "sm"
      ? "px-2 py-1 text-sm"
      : size === "md"
        ? "px-4 py-2 text-base"
        : "px-6 py-3 text-lg";
  const severityClassName =
    severity === "primary"
      ? "bg-blue-500 text-white"
      : severity === "secondary"
        ? "bg-gray-500 text-white"
        : "bg-red-500 text-white";
  const buttonClassName =
    `uppercase cursor-pointer rounded-md ${isDisabled ? "opacity-50 cursor-not-allowed" : ""} relative ${sizeClassName} ${severityClassName} ${className ?? ""}`.trim();
  if (type === "route" && href) {
    return (
      <Link
        className={buttonClassName}
        to={isDisabled ? "" : href}
        onClick={(e) => {
          if (isDisabled) {
            e.preventDefault();
          }
        }}
      >
        <ButtonContent loading={loading}>{children}</ButtonContent>
      </Link>
    );
  } else if (type === "button" || type === "submit" || type === "reset") {
    return (
      <button
        className={buttonClassName}
        disabled={isDisabled}
        type={type}
        onClick={onClick ?? undefined}
      >
        <ButtonContent loading={loading}>{children}</ButtonContent>
      </button>
    );
  }
  throw new Error(`Invalid button type: ${type}`);
}

export function ButtonContent({
  children,
  loading,
}: {
  children: React.ReactNode;
  loading: boolean;
}) {
  return (
    <>
      <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center">
        {loading && <Spinner />}
      </div>
      <div className={`w-full ${loading ? "opacity-0" : ""}`}>{children}</div>
    </>
  );
}
